"use client";

import { createSVGIcon } from "@faire/slate/lib/iconUtils";
import React from "react";

// https://docs.adyen.com/online-payments/api-only/downloading-logos

/** @optimized using svgo:^3.0.2 */
export const IdealSquare = createSVGIcon(
  <>
    <path
      d="M3 .25h34A2.75 2.75 0 0 1 39.75 3v34A2.75 2.75 0 0 1 37 39.75H3A2.75 2.75 0 0 1 .25 37V3A2.75 2.75 0 0 1 3 .25Z"
      fill="#fff"
      stroke="#AAA"
      strokeWidth=".5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.979 30h-10.32C9.743 30 9 29.262 9 28.353V11.647c0-.91.743-1.647 1.66-1.647h10.319c9.792 0 11.253 6.255 11.253 9.979C32.232 26.439 28.23 30 20.98 30m-10.32-19.45c-.613 0-1.106.488-1.106 1.097v16.706c0 .609.493 1.098 1.106 1.098h10.32c6.897 0 10.7-3.364 10.7-9.472 0-8.203-6.707-9.43-10.7-9.43zm1.781 10.81a1.61 1.61 0 0 0 1.616-1.604 1.61 1.61 0 0 0-1.616-1.605 1.61 1.61 0 0 0-1.616 1.605 1.61 1.61 0 0 0 1.616 1.604m-1.227 4.041a2.435 2.435 0 0 0 2.446 2.428h.008v-4.324c0-.678-.553-1.218-1.227-1.218-.683 0-1.227.549-1.227 1.218z"
      fill="#000"
    />
    <path
      d="M15.324 13.26v14.57h6.387c5.8 0 8.315-3.253 8.315-7.851 0-4.402-2.515-7.817-8.315-7.817h-5.28c-.614 0-1.107.498-1.107 1.098"
      fill="#C06"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.204 18.118a1.9 1.9 0 0 0-.63-.103v-.01h-1.496v3.484h1.513c.267 0 .5-.051.7-.137.198-.094.363-.214.492-.369a1.6 1.6 0 0 0 .294-.558c.06-.214.095-.446.095-.703a2.2 2.2 0 0 0-.12-.755 1.8 1.8 0 0 0-.338-.532 1.4 1.4 0 0 0-.51-.317m-.354 2.685a1.1 1.1 0 0 1-.329.052v.008h-.682v-2.196h.553q.283 0 .475.077a.8.8 0 0 1 .311.232.9.9 0 0 1 .173.36c.035.137.052.3.052.472 0 .197-.026.352-.078.489a1 1 0 0 1-.198.326.65.65 0 0 1-.277.18m4.442-2.145v-.653h-2.618v3.484h2.662v-.643h-1.893v-.85h1.702v-.591h-1.702v-.747zm2.645-.643 1.314 3.483h-.804l-.268-.772h-1.313l-.277.772h-.778l1.323-3.483zm.043 2.136-.44-1.278h-.009l-.458 1.278zm2.524.704v-2.84h-.77v3.483h2.481v-.643z"
      fill="#fff"
    />
  </>,
  "IdealSquare",
  {
    viewBox: "0 0 40 40",
    titleAccess: "Square iDeal Icon",
    fill: "none",
  }
);
